import { render } from "./OttoPhone.vue?vue&type=template&id=8b18f2ac&scoped=true&ts=true"
import script from "./OttoPhone.vue?vue&type=script&lang=ts"
export * from "./OttoPhone.vue?vue&type=script&lang=ts"

import "./OttoPhone.vue?vue&type=style&index=0&id=8b18f2ac&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b18f2ac"]])

export default __exports__